import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { WhyChooseUs } from './components/WhyChooseUs';
import { InsuranceSection } from './components/InsuranceSection';
import { ProgramsSection } from './components/ProgramsSection';
import { SedesSection } from './components/SedesSection';
import { TeamSection } from './components/TeamSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ComparisonSection } from './components/ComparisonSection';
import { HowItWorks } from './components/HowItWorks';
import { ContactSection } from './components/ContactSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileBar } from './components/StickyMobileBar';
export function App() {
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <Header data-id="element-2" />

      <main className="flex-grow" data-id="element-3">
        <Hero data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <WhyChooseUs data-id="element-7" />
        <InsuranceSection data-id="element-8" />
        <ProgramsSection data-id="element-9" />
        <SedesSection data-id="element-10" />
        <TeamSection data-id="element-11" />
        <TestimonialsSection data-id="element-12" />
        <ComparisonSection data-id="element-13" />
        <HowItWorks data-id="element-14" />
        <ContactSection data-id="element-15" />
        <FAQSection data-id="element-16" />
        <FinalCTA data-id="element-17" />
      </main>

      <Footer data-id="element-18" />
      <StickyMobileBar data-id="element-19" />
    </div>;
}